import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { ErrorDialogService } from "./services/error-dialog.service";
import { LoadingDialogService } from "./services/loading-dialog.service";
import { NaoService } from "./services/nao.service";
import { MaterialModule } from "../material.module";
import { ErrorDialogComponent } from './components/error-dialog/error-dialog.component';
import { LoadingDialogComponent } from './components/loading-dialog/loading-dialog.component';
import {MAT_DIALOG_DEFAULT_OPTIONS} from "@angular/material/dialog";
import {SettingsComponent} from "./components/settings/settings.component";
import {SettingsModule} from "./components/settings/settings.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {LoginComponent} from "./components/login/login.component";
import {CustomValidators} from "./validators/custom-validator";

import {SsnMaskPipe} from "./pipe/ssn-mask.pipe";
import {SafePipe} from "./pipe/safe.pipe";
import { MaintenanceBannerComponent } from "./components/maintenance-banner/maintenance-banner.component";
import {FlexModule} from "@angular/flex-layout";
import { DeleteDialogComponent } from './components/delete-dialog/delete-dialog.component';
import { ToastrModule } from "ngx-toastr";
import {InternalDetailsComponent} from "./components/internal-details/internal-details.component";
import { CustomFilterComponent } from './components/custom-filter/custom-filter.component';

const sharedComponents = [LoadingDialogComponent, ErrorDialogComponent, SettingsComponent, LoginComponent, MaintenanceBannerComponent, InternalDetailsComponent, CustomFilterComponent];

@NgModule({
    declarations: [...sharedComponents, LoadingDialogComponent, SsnMaskPipe, SafePipe, DeleteDialogComponent],
    imports: [CommonModule, RouterModule, MaterialModule, SettingsModule,FormsModule, ReactiveFormsModule, FlexModule, ToastrModule.forRoot({
        maxOpened: 1,
        progressBar: true,
        progressAnimation: 'decreasing',
        preventDuplicates: true,
      })],
    exports: [...sharedComponents, MaterialModule, FormsModule, ReactiveFormsModule, SsnMaskPipe, SafePipe],
    providers: [ErrorDialogService, LoadingDialogService, CustomValidators, NaoService,
        { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: true } },
    ]
})
export class SharedModule {}
